import { makeAutoObservable } from 'mobx';
import { validateGrabCents } from './validateGrabCents';

export class GrabCentsData {
  grabCentsMode = 'quantity';
  takeProfitMode = 'DOLLARS';
  percentagePerLevel = [];
  quantityPerLevel = [];
  centsPerLevel = [];
  trailPercent = 0;
  trailQuantity = 0;
  trailAmount = 0;

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach((field) => {
        if (field === 'percentagePerLevel') {
          this.percentagePerLevel = initialData.percentagePerLevel.map(
            (item) => Number(item) * 100
          );
        } else if (field === 'trailPercent') {
          this.trailPercent = Number(initialData.trailPercent) * 100;
        } else {
          this[field] = initialData[field];
        }
      });
    }
  }

  //common methods
  resetToDefaults = () => {
    this.grabCentsMode = 'quantity';
    this.takeProfitMode = 'DOLLARS';
    this.percentagePerLevel = [];
    this.quantityPerLevel = [];
    this.centsPerLevel = [];
    this.trailPercent = 0;
    this.trailQuantity = 0;
    this.trailAmount = 0;
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const data = {
      percentagePerLevel: this.percentagePerLevel,
      quantityPerLevel: this.quantityPerLevel,
      trailQuantity: this.trailQuantity,
      centsPerLevel: this.centsPerLevel,
      trailAmount: this.trailAmount,
      trailPercent: this.trailPercent,
    };
    const result = validateGrabCents(data);
    return result;
  };

  returnJson = () => {
    if (this.grabCentsMode === 'percentage') {
      return {
        percentagePerLevel: this.percentagePerLevel,
        centsPerLevel: this.centsPerLevel,
        takeProfitMode: this.takeProfitMode,
        trailAmount: this.trailAmount,
        trailPercent: this.trailPercent,
      };
    } else {
      return {
        quantityPerLevel: this.quantityPerLevel,
        centsPerLevel: this.centsPerLevel,
        takeProfitMode: this.takeProfitMode,
        trailAmount: this.trailAmount,
        trailQuantity: this.trailQuantity,
      };
    }
  };

  //specific methods
  setGrabCentsMode = (string) => {
    this.grabCentsMode = string;
  };
  setTakeProfitMode = (string) => {
    this.clearArrays();
    this.takeProfitMode = string;
  };
  addValuePair = (cent, variableValue) => {
    if (this.grabCentsMode === 'percentage') {
      this.centsPerLevel.push(cent);
      this.percentagePerLevel.push(variableValue);
    } else {
      this.centsPerLevel.push(cent);
      this.quantityPerLevel.push(variableValue);
    }
  };
  removeValuePair = (index) => {
    const newCents = this.centsPerLevel.filter((_, i) => i !== index);
    this.centsPerLevel = newCents;
    if (this.grabCentsMode === 'percentage') {
      const newPercentages = this.percentagePerLevel.filter(
        (_, i) => i !== index
      );
      this.percentagePerLevel = newPercentages;
    } else {
      const newQuantities = this.quantityPerLevel.filter((_, i) => i !== index);
      this.quantityPerLevel = newQuantities;
    }
  };
  clearArrays = () => {
    this.centsPerLevel = [];
    this.percentagePerLevel = [];
    this.quantityPerLevel = [];
  };
  addCentsValue = (number) => {
    this.centsPerLevel.push(number);
  };
  removeCentsValue = (index) => {
    const newCentsArr = this.centsPerLevel.filter((_, i) => i !== index);
    this.centsPerLevel = newCentsArr;
  };
  addQuantityValue = (number) => {
    this.quantityPerLevel.push(number);
  };
  removeQuantityValue = (index) => {
    const newQuantityArr = this.quantityPerLevel.filter((_, i) => i !== index);
    this.quantityPerLevel = newQuantityArr;
  };
  addPercentageValue = (number) => {
    this.percentagePerLevel.push(number);
  };
  removePercentageValue = (index) => {
    const newPercentageArr = this.percentPerLevel.filter((_, i) => i !== index);
    this.percentagePerLevel = newPercentageArr;
  };
  setTrailPercent = (number) => {
    this.trailPercent = number;
  };
  setTrailQuantity = (number) => {
    this.trailQuantity = number;
  };
  setTrailAmount = (number) => {
    this.trailAmount = number;
  };
}
